<template>
  <div></div>
</template>
<script>
import { Howl, Howler } from "howler";

import { mapState } from "vuex";
export default {
  name: "AudioManager",
  data() {
    return {
      sounds: {}
    };
  },
  computed: {
    ...mapState(["sections", "ambience_max_volume"])
  },
  mounted() {
    this.$bus.$on("on-request-audio", this.on_request_audio);
    this.$bus.$on("on-request-audio-stop", this.on_request_audio_stop);
    this.$bus.$on("on-request-ambience-fade", this.fade_ambience);
    this.$bus.$on("try-to-lower-ambience", this.try_to_lower_ambience);
    this.$bus.$on("try-to-increase-ambience", this.try_to_increase_ambience);
    this.$bus.$on("on-request-fade-and-stop", this.on_request_fade_and_stop);
    this.create_sound("ambience", "static/audio/ambience", 0);
    console.log(this.sections);
    this.sections.forEach((item) => {
      if (item.has_voiceover) {
        this.create_sound(
          item.id,
          "static/content/audio/vo/" + item.id,
          this.$store.state.voice_volume
        );
      }
    });

    this.sounds["ambience"].loop(true);
  },
  methods: {
    create_sound(name, src, volume) {
      this.sounds[name] = new Howl({
        src: [src + ".webm", src + ".mp3"],
        volume: volume,
        rate: 1
      });
      if (name != "ambience") {
        this.sounds[name].on(
          "end",
          function () {
            this.$bus.$emit("on-audio-end", name);
          }.bind(this)
        );
      }
    },
    play_sound(name) {
      this.sounds[name].play();
    },
    on_request_audio(name) {
      if (!this.sounds[name].playing()) {
        this.sounds[name].play();
      }
    },
    on_request_audio_stop(name) {
      if (this.sounds[name].playing()) {
        this.sounds[name].stop();
      }
    },
    on_request_fade_and_stop(name) {
      if (this.sounds[name].playing()) {
        this.sounds[name].once(
          "fade",
          (() => {
            this.sounds[name].stop();
          }).bind(this)
        );
        this.sounds[name].fade(this.sounds[name].volume(), 0, 600);
      }
    },
    fade_ambience(to) {
      //console.log('fade ambiens to', to)

      let new_vol =
        to > this.ambience_max_volume ? this.ambience_max_volume : to;
      this.sounds["ambience"].fade(
        this.sounds["ambience"].volume(),
        new_vol,
        800
      );
      this.$store.dispatch("set_simple_val", {
        name: "ambience_current_vol",
        val: new_vol
      });
    },
    try_to_lower_ambience(to) {
      console.log(
        "try to lower ambience from ",
        this.sounds["ambience"].volume(),
        "to",
        to
      );
      if (
        this.sounds["ambience"].volume() > 0 &&
        to != this.sounds["ambience"].volume()
      ) {
        this.fade_ambience(to);
      }
    },
    try_to_increase_ambience(to) {
      console.log(
        "try to increase ambience from ",
        this.sounds["ambience"].volume(),
        "to",
        to
      );
      if (
        this.sounds["ambience"].volume() != 0 &&
        to != this.sounds["ambience"].volume()
      ) {
        this.fade_ambience(to);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AudioManager.vue